import React from 'react';
import TitleText from './TitleText';
import {
	Box,
	Container,
	Grid,
	Drawer,
	makeStyles,
	Divider,
	Avatar,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Chip,
} from '@material-ui/core';
import tata from '../../assets/images/tata.png';
import payment from '../../assets/images/payment.png';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import LocalPostOfficeIcon from '@material-ui/icons/LocalPostOffice';
import YouTubeIcon from '@material-ui/icons/YouTube';
import BodyText from './BodyText';
const About = () => {
	return (
		<>
			<Box mt={'30px'}>
				<TitleText four textStyle={{ fontFamily: 'Roboto Serif, sans-serif' }}>
					About MusafirBazar.com
				</TitleText>
				<BodyText
					three
					textStyle={{
						marginTop: 20,
						fontFamily: 'Roboto Serif, sans-serif',
						color: '#8f8f8f',
						fontWeight: 500,
					}}>
					Ever wished that there were an escape button on the keyboard of life?
					Well, since there isn’t, we are there for you. The universal truth is
					that every person in this universe needs a break at some point - A
					break from the mundane routines
				</BodyText>
			</Box>
			<Divider style={{ marginTop: 20 }} />
			<Grid container>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						mt={'30px'}
						p={'5px'}
						justifyContent='space-between'
						alignItems='center'>
						<LocationOnIcon />
						<TitleText
							three
							textStyle={{
								marginLeft: 20,
								fontFamily: 'Roboto Serif, sans-serif',
							}}>
							1st Floor,New Tech Grand, Bank More, Dhanbad-826001
						</TitleText>
						<div style={{ borderLeft: '1px solid grey', height: '60px' }}></div>
					</Box>
				</Grid>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						justifyContent='space-between'
						alignItems='center'
						p={'5px'}
						mt={'30px'}>
						<LocalPhoneIcon />
						<TitleText
							three
							textStyle={{ fontFamily: 'Roboto Serif, sans-serif' }}>
							+91 887-777-3388<br></br> +91 887-777-3388
						</TitleText>
						<div style={{ borderLeft: '1px solid grey', height: '60px' }}></div>
					</Box>
				</Grid>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						mt={'30px'}
						p={'5px'}
						mb={'30px'}
						justifyContent='space-between'
						alignItems='center'>
						<LocalPostOfficeIcon />
						<TitleText
							three
							textStyle={{ fontFamily: 'Roboto Serif, sans-serif' }}>
							sales@musafirbazar.com
						</TitleText>
						<div style={{ borderLeft: '1px solid grey', height: '60px' }}></div>
					</Box>
				</Grid>
				<Grid item xs={6} lg={3}>
					<Box display='flex' mt={'46px'} p={'5px'} alignItems='center'>
						<YouTubeIcon />
						<i class='fa-brands fa-twitter' style={{ marginLeft: 10 }}></i>
						<i class='fa-brands fa-instagram' style={{ marginLeft: 10 }}></i>
						<i class='fa-brands fa-facebook' style={{ marginLeft: 10 }}></i>
					</Box>
				</Grid>
			</Grid>
			<Divider style={{ marginBottom: 30 }} />
			{/* <Grid container>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						justifyContent='space-between'
						alignItems='center'
						p={'5px'}>
						<Box>
							<Box
								display='flex'
								p={'5px'}
								style={{ border: '1px solid #25d366' }}
								justifyContent='space-between'
								alignItems='center'>
								<WhatsAppIcon />
								<TitleText two textStyle={{ marginLeft: 20 }}>
									Connect with on WhatApp
								</TitleText>
							</Box>
							<Box
								display='flex'
								p={'5px'}
								mt={'10px'}
								style={{ border: '1px solid #25d366' }}
								justifyContent='space-between'
								alignItems='center'>
								<WhatsAppIcon />
								<TitleText two textStyle={{ marginLeft: 20 }}>
									Connect with on WhatApp
								</TitleText>
							</Box>
							<Box
								display='flex'
								p={'5px'}
								mt={'10px'}
								style={{ border: '1px solid #25d366' }}
								justifyContent='space-between'
								alignItems='center'>
								<WhatsAppIcon />
								<TitleText two textStyle={{ marginLeft: 20 }}>
									Connect with on WhatApp
								</TitleText>
							</Box>
						</Box>
						<Box></Box>
						<Box></Box>
						<div
							style={{ borderLeft: '1px solid grey', height: '160px' }}></div>
					</Box>
				</Grid>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						justifyContent='space-between'
						alignItems='center'>
						<Box alignItems='center' p={'5px'}>
							{[0, 1, 2, 3, 4].map((i) => {
								return (
									<>
										<TitleText two>About Us</TitleText>
									</>
								);
							})}
						</Box>
						<Box></Box>
						<div
							style={{ borderLeft: '1px solid grey', height: '160px' }}></div>
					</Box>
				</Grid>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						justifyContent='space-between'
						alignItems='center'>
						<Box alignItems='center' p={'5px'}>
							{[0, 1, 2, 3, 4].map((i) => {
								return (
									<>
										<TitleText two>Enquiry</TitleText>
									</>
								);
							})}
						</Box>
						<div
							style={{ borderLeft: '1px solid grey', height: '160px' }}></div>
					</Box>
				</Grid>
				<Grid item xs={6} lg={3}>
					<Box
						display='flex'
						justifyContent='space-between'
						alignItems='center'>
						<Box alignItems='center' p={'8px'}>
							{[0, 1, 2, 3, 4].map((i) => {
								return (
									<>
										<TitleText two>Make Payment</TitleText>
									</>
								);
							})}
						</Box>
						<Box></Box>
						<Box></Box>
						<Box></Box>
						<Box></Box>
					</Box>
				</Grid>
			</Grid> */}
			<Grid container style={{ marginTop: 50 }} spacing={2}>
				{/* <Grid item xs={12} lg={8}>
					<Box
						style={{
							backgroundImage: `url(${tata})`,
							width: '100%',
							height: '80px',
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'auto',
							backgroundSize: 'contain',
						}}></Box>
				</Grid> */}
				<Grid item xs={12} lg={4}>
					<Box display='flex' alignItems='center'>
						<Box>
							<TitleText two textStyle={{ fontFamily: 'sans-serif' }}>
								Payment Options:
							</TitleText>
							<BodyText two textStyle={{ fontFamily: 'sans-serif' }}>
								We Accept here
							</BodyText>
						</Box>
						<img src={payment}></img>
					</Box>
				</Grid>
			</Grid>
			<Box display='flex' alignItems='center'>
				<TitleText two>Note:</TitleText>
				<BodyText
					three
					textStyle={{
						marginLeft: 5,
						fontFamily: 'sans-serif',
						// color: '#8f8f8f',
						fontWeight: 600,
					}}>
					All claims, disputes and litigation relating to online booking through
					this website anywhere from India or abroad shall be subject to
					jurisdiction of Courts of Delhi only.
				</BodyText>
			</Box>
		</>
	);
};

export default About;
